export default {
  en: {
    selectTab: 'Select tab'
  },
  fr: {
    selectTab: 'Sélectionner un onglet'
  }
};